import axios from "axios";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import { getAuthToken, getcompanyId, getFacilityId } from "../../utility/tokenUtility";


const fetchAssetNo = async () => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const [responseFems, responseBems] = await Promise.all([
      axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config),
      axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config)
    ]);
    const combinedData = [...responseFems.data, ...responseBems.data];
    return combinedData;
  }
  catch (error) {
    console.log(error);
  }
};

const fetchAssetNobyService = async (serviceType) => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    let response = [];
    if(serviceType === "FEMS" || serviceType === "fem"){
      response = await axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config);
    }else if (serviceType === "BEMS" || serviceType === "bem"){
      response = await axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetWorkOrderAssetNoFetchList/${facilityId},1,1000000`, config);
    }

    return response.data;
  }
  catch (error) {
    console.log(error);
  }
};

const updateRepairTracker = async (serviceType, payload, categoryType, assementsId) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledworepairdetails" : "unscheduledworepairdetails";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${assementsId}`, payload, config);

    return response.data;

  } catch (error) {
    console.log(error);
  }
};
const fetchWorkRequestNo = async () => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const [responseFems, responseBems] = await Promise.all([
      axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkRequestList/${facilityId},1,1000000`, config),
      axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetWorkRequestList/${facilityId},1,1000000`, config)
    ]);

    const combinedData = [...responseFems.data, ...responseBems.data];
    return combinedData;
  }
  catch (error) {
    console.log(error);
  }
};

const lovOptions = async () => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${FemsGraph}/api/CommonLov/GetCommonLovList`, config);

    return response?.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchTypes = async (selectedCategory) => {
  try {
    const token = getAuthToken("id_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    // const response = await axios.get(`${FemsGraph}/api/Femworkrequesttypelist/Getworkrequestordertype/${selectedCategory}`, config);
    const response = await axios.get(`${FemsGraph}/api/Femworkrequesttypelist/Getworkrequestordertype/${selectedCategory}`, config);

    return response?.data;

  } catch (error) {
    console.error('Error fetching types:', error);
  }
};

const createBasicDetails = async (serviceType, payload, categoryType) => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const checkCategory = categoryType === "scheduled" ? "scheduledworkorderheaders" : "unscheduledworkorderheaders";

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}`, payload, config);
    return response.data;
  } catch (error) {
    return error;
  }
};

const updateWorkRequestNO = async (serviceType, payload, categoryType) => {

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const url = serviceType === "fem" ?  `${FemsGraph}/api/Femworkrequesttypelist/UpdateDerpartmentworkrequest/${payload?.id}` : `${BemsGraph}/api/GraphBemworkrequesttypelist/UpdateDerpartmentworkrequestbems/${payload?.id}`
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    return error;
  }
};

const workordernoGeneration = async (categoryType) => {
  const facilityId = getFacilityId('facilityId');
  const checkCode = categoryType === "scheduled" ? "scheduledworkorderheaders" : "MWR";

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${MasterGraph}/api/GraphDocumentSerialNumber/GetDocumentSerialNumberDetails/${facilityId}/${checkCode}/${token}`, config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};


const getByIdBasicdetails = async (serviceType, basicdetailsdataId, categoryType) => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const checkCategory = categoryType === "scheduled" ? "scheduledworkorderheaders" : "unscheduledworkorderheaders";

    const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${basicdetailsdataId}`, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const updateBasicDetails = async (serviceType, payload, categoryType) => {
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
    const checkCategory = categoryType === "Scheduled" ? "scheduledworkorderheaders" : "unscheduledworkorderheaders";
    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${payload?.id}`, payload, config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};


const getWorkOrderSummary = async (serviceType, workorderId, categoryType,workOrderType) => {
  const facilityId = getFacilityId('facilityId');


  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

    if(categoryType === "Scheduled" && workOrderType === "PPM"){
      const response = await axios.get(`${checkGraph}/api/GraphWorkorderReport/GetScheduleWorkorderFetchByWorkOrderId/${facilityId},${workorderId},${token}`, config);
      return response.data;

    }  else if (categoryType === "Scheduled" && workOrderType === "PDM"){
      let checkServiceName = serviceType === "fem" ? "Femunscheduledworkorder" : "Bemunscheduledworkorder";
      const response = await axios.get(`${checkGraph}/api/${checkServiceName}/GetPDMScheduleWorkorderFetchByWorkOrderId/${facilityId},${workorderId},${token}`, config);
      return response.data;
    } else if (categoryType === "Unscheduled"){
      const response = await axios.get(`${checkGraph}/api/GraphWorkorderReport/GetUnScheduleWorkorderFetchByWorkOrderId/${facilityId},${workorderId},${token}`, config);
      return response.data;
    }

  } catch (error) {
    console.log(error);
  }
};

const fetchItemCodeoptions = async (serviceType, categoryType) => {
  const facilityId = getFacilityId('facilityId');
  const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder/GetWorkOrderItemDetailsFetchList/${facilityId},1,100000`, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const addItemPartCode = async (serviceType, payload, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledwopartsreplacedetails" : "unscheduledwopartsreplacedetails";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}${checkCategory} `, payload, config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const getItemPartCode = async (serviceType, workorderId, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "Femunscheduledworkorder" : "Bemunscheduledworkorder";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "GetscheduledwopartsreplaceList" : "GetunscheduledwopartsreplaceList";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}/${checkCategory}/${workorderId},1,2000`, config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const getRepairDetails = async (serviceType, assessmentId, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "Femunscheduledworkorder" : "Bemunscheduledworkorder";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "GetscheduledworepairdetailsList" : "GetunscheduledworepairdetailsList";

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    // Construct the API URL correctly with proper formatting
    const url = `${checkGraph}/api/${checkFEMorBEM}/${checkCategory}/${assessmentId},1,2000`;

    // Make the API request
    const response = await axios.get(url, config);



    // Return the data from the API call to the calling function
    return response.data;
  } catch (error) {
    console.error('Error fetching repair details:', error);
    // Optionally throw the error to handle it in the calling function
    throw error;
  }
};


const updateItemPartCode = async (serviceType, payload, basicDetailsId, categoryType) => {

  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledwopartsreplacedetails" : "unscheduledwopartsreplacedetails";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${basicDetailsId}`, payload, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const deleteItemPartCode = async (serviceType, id, categoryType) => {

  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledwopartsreplacedetails" : "unscheduledwopartsreplacedetails";

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.delete(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${id}`, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};


const addCompletionInfo = async (serviceType, payload, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledwocompletiondetails" : "unscheduledwocompletiondetails";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}`, payload, config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const updateCompletionInfo = async (serviceType, id, payload, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledwocompletiondetails" : "unscheduledwocompletiondetails";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${id}`, payload, config);


    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};


const updateCompletionInfonotification = async (serviceType, id, facilityid, categoryType) => {
  const checkFEMorBEM = serviceType === "bem" ? "Graphbemworkorder/GetCompletedWororderOrderNotification" : "Graphfemworkorder/GetCompletedWororderOrderNotification";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? 2 : 1;
  
  
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}/${id}/${facilityid}/${checkCategory}`, config);


    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

const fetchEmployeeDetails = async () => {
  const facilityId = getFacilityId('facilityId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${FemsGraph}/api/Femunscheduledworkorder/GetWorkOrderEmployeeDetailsFetchList/${facilityId}`, config);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const fetchTaskCode = async (serviceType,workGroupId) => {
  const facilityId = getFacilityId('facilityId');
  const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.get(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder/GetWOAssessmentTaskCodeFetchList/${facilityId},${workGroupId},1,100000`, config);
    return response.data;
  }
  catch (error) {
    console.log(error);
  }
};

const fetchVendorDetails = async () => {
  const companyId = getcompanyId('companyId');
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${MasterGraph}/api/GraphMaspomvendors/GetMaspomvendorsByFacilityId/${companyId}?Size=100000`, config);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const addAssessmentsDetails = async (serviceType, payload, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledwoassessmentheaders" : "unscheduledwoassessmentheaders";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}`, payload, config);

    return response.data;

  } catch (error) {
    console.log(error);
    return error;
  }
};

const updateAssessmentsDetails = async (serviceType, payload, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledwoassessmentheaders" : "unscheduledwoassessmentheaders";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${payload?.id}`, payload, config);
    return response.data;

  } catch (error) {
    console.log(error);
    return error;
  }
};


const updateAssessmentsDetailsInWebForm = async (serviceType, payload, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder`, payload, config);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const sendVendorEmail = async (serviceType, payload) => {
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;

  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/WorkOrderEmailSend`, payload, config);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};


const addRepairTracker = async (serviceType, payload, categoryType) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledworepairdetails" : "unscheduledworepairdetails";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.post(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}`, payload, config);

    return response.data;

  } catch (error) {
    console.log(error);
  }
};
const deleteRepairTracker = async (serviceType, categoryType, id) => {
  const checkFEMorBEM = serviceType === "fem" ? "fem" : "bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkCategory = categoryType === "Scheduled" ? "scheduledworepairdetails" : "unscheduledworepairdetails";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };

    const response = await axios.delete(`${checkGraph}/api/${checkFEMorBEM}${checkCategory}/${id}`, config);

    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const workorderStatusValue = async (serviceType, WorkOrderId, status, percentage, Category) => {
  const facilityId = getFacilityId('facilityId');
  const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
        "Content-Type": "application/json" // Ensure proper content type
      },
    };
    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder/UpdateWorkOrderStatus/${WorkOrderId},${status},${percentage},${Category},${facilityId}`,{},config);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const workorderPushNotificationStatus = async (serviceType, WorkOrderId, status, percentage, Category) => {
  const facilityId = getFacilityId('facilityId');
  const checkFEMorBEM = serviceType === "fem" ? "Fem" : "Bem";
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
        "Content-Type": "application/json" // Ensure proper content type
      },
    };
    const response = await axios.put(`${checkGraph}/api/${checkFEMorBEM}unscheduledworkorder/UpdateWorkOrderPushNotificationStatus/${WorkOrderId},${status},${percentage},${Category},${facilityId}`,{},config);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};

const autoAssignedEmp = async (serviceType, WorkOrderId) => {
  const checkGraph = serviceType === "fem" ? FemsGraph : BemsGraph;
  const checkFemorBem = serviceType === "fem" ? "Graphfemworkorder" : "Graphfemworkorder";
  try {
    const token = getAuthToken("id_token"); // Example: Retrieve token from localStorage
    const config = {
      headers: {
        Authorization: `Bearer ${token}`, // Attach bearer token to request header
      },
    };
    const response = await axios.get(`${checkGraph}/api/${checkFemorBem}/Getacceptitembyworkorderid_mobile/${WorkOrderId}`,config,);
    return response.data;

  } catch (error) {
    console.log(error);
  }
};


const workOrderSummaryRepositry = {
  fetchAssetNo,
  fetchAssetNobyService,
  getWorkOrderSummary,
  createBasicDetails,
  updateWorkRequestNO,
  workordernoGeneration,
  updateBasicDetails,
  getByIdBasicdetails,
  fetchWorkRequestNo,
  lovOptions,
  fetchTypes,
  fetchItemCodeoptions,
  addItemPartCode,
  getItemPartCode,
  updateItemPartCode,
  deleteItemPartCode,
  addCompletionInfo,
  updateCompletionInfo,
  fetchEmployeeDetails,
  fetchTaskCode,
  addAssessmentsDetails,
  updateAssessmentsDetails,
  updateAssessmentsDetailsInWebForm,
  addRepairTracker,
  deleteRepairTracker,
  updateRepairTracker,
  fetchVendorDetails,
  workorderStatusValue,
  workorderPushNotificationStatus,
  getRepairDetails,
  sendVendorEmail,
  autoAssignedEmp,
  updateCompletionInfonotification
};

export default workOrderSummaryRepositry;